/* eslint-disable */
/**
 * template created by GreatJiang
 * 通用Vue模板
 */
'use strict';
!(function($, undefined) {
  class Activity {
    constructor() {
      this.refsrc = commonObj.utils.getQueryStrFn('refsrc') || 'none';
      this.siteId = '' //site id
      this.outCB = (commonObj.browser.ua.indexOf('changba') < 0) || commonObj.browser.isQQorWeChat || commonObj.browser.isWeibo || /cblive/.test(commonObj.browser.ua);
      //课程id
      this.lessonid = commonObj.utils.getQueryStrFn('lessonid');
      this.isCB = commonObj.utils.getQueryStrFn('isCB');
    }

    init() {
      const _czc = this._czc = window._czc || [];
      if (_czc) {
        _czc.push(["_setAccount", this.siteId]);
        _czc.push(["_trackEvent", this.refsrc, commonObj.data.outChangba ? 'outCB' : 'inCB', 'loaded', 0, 'body']);
      }
      // if(this.isCB) {
      //   window.location.href ='changba://?ac=musiclesson&lessonid=' + this.lessonid
      // }
      this.vueAction()
      this.shareAll()
    }

    vueAction() {
      const activityThis = this;
      const u = navigator.userAgent;
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      const vivo = u.toLowerCase().indexOf('vivo');
      const oppo = u.toLowerCase().indexOf('oppo');
      const wx = u.toLowerCase();
      return new Vue({
        el: '#app',
        filters: {

        },
        data() {
          return {
            loadingFlag: false, //loading
            mesLayerFlag: false, //信息弹窗
            mesContent: '',  //信息弹窗内容
            lessonInfo: {},
            lessonList: [],
            cur: 0
          }
        },
        created() {
          const self = this;
          //${activityThis.lessonid}
          // api/activity/curriculumlearning/info
          axios.post('/api/activity/musicteach/info', `lessonid=${activityThis.lessonid}`)
            .then(res => {
              if (res.data.code === 1) {
                self.lessonInfo = res.data.data.info;
                self.lessonList = res.data.data.list;
              }
            });
        },
        mounted() {
          $('#mask').on('click', function() {
            $(this).hide();
          });
        },
        methods: {
          //切换
          tabChange(i) {
            console.log(i);
            this.cur = i;
          },
          canAction() {
            const regex = /changba\/(\d+)\.(\d+)\.(\d+)/
            const u = navigator.userAgent
            const ver = u.match(regex)
            if (ver && ver[1] == 8) {
              if (ver[2] >= 9 && ver[3] > 0) {
                return true
              } else {
                return false
              }
            }
            else if (ver && ver[1] >= 9) {
              return true
            } else {
              return false
            }
          },
          goAction() {
            if (activityThis.outCB) {
              this.openApp();
            } else {
              if (this.canAction()) {
                //版本8.9以上
                window.location.href = 'changba://?ac=musiclesson&lessonid=' + activityThis.lessonid
              } else {
                alert('下载最新版本唱吧APP，学习更多唱歌技巧，让你霸榜不费力~')
              }
            }
          },
          mesLayerAction(content) {
            // 信息弹窗
            this.mesLayerFlag = true
            this.mesContent = content
            setTimeout(() => {
              this.mesLayerFlag = false
              this.mesContent = ''
            }, 2000)
          },
          // 添加一个站外打开的常用方法
          openApp() {
            if (activityThis.outCB) {
              if (wx.match(/micromessenger/i) == "micromessenger") {
                $('#mask').show();
              } else {
                const c = confirm('前往唱吧进行参与~');
                c && commonObj.utils.openApp(false, 'https://changba.com/njwap/chanpin/musicTeaching/new/main?lessonid=' + activityThis.lessonid, $('body'));
              }
              return false;
            }
          }
        }
      })
    }

    shareAll() {
      let _url = '';
      _url = 'https://changba.com/njwap/chanpin/musicTeaching/new/main?wScratch=1&lessonid=' + this.lessonid
      const params = {
        title: '音乐课程教学',
        content: '音乐课程教学',
        weibocontent: '音乐课程教学',
        imageurl: 'http://cb.cdn.changbaimg.com/images/logo_300x300.jpg',
        thumburl: 'http://cb.cdn.changbaimg.com/images/logo_300x300.jpg',
        targeturl: _url
      };
      window.setShareUrlParams = function() {
        return JSON.stringify(params);
      };
      commonObj.data.setWXShare = function(wx) {
        const shareData = {
          title: '音乐课程教学',
          link: 'https://changba.com/njwap/chanpin/musicTeaching/new/main?wScratch=1&lessonid=' + this.lessonid,
          imgUrl: 'https://cb.cdn.changbaimg.com/images/logo_300x300.jpg',
          desc: '音乐课程教学'
        };
        wx.onMenuShareTimeline(shareData);
        wx.onMenuShareAppMessage(shareData);
        wx.onMenuShareQQ(shareData);
        wx.onMenuShareWeibo(shareData);
        wx.onMenuShareQZone(shareData);
      };
    }
  }

  new Activity().init();
})(Zepto);
